/**
 * @file
 * GRISCHA behaviors.
 */
(function ($, Drupal) {

  'use strict';

  const options = {
    method: 'GET',
    mode: 'no-cors'
  };

  let playStateRSO = false;
  let playStateGrischa = false;

  // Alle Audioplayer auflisten
  const audioPlayers = {
    rso: $('#audio-rso')[0],
    grischa: $('#audio-grischa')[0]
  };

  // Funktion zum Zurücksetzen aller Audioplayer
  function resetAllPlayers(except) {
    for (const [key, player] of Object.entries(audioPlayers)) {
      player.pause();
      player.load();
      player.currentTime = 0;
      player.volume = 0.5; // Standardlautstärke
      player.muted = false;
      // Entferne den "playing"-Status und setze auf initialen Zustand
      $('.player.' + key).removeClass("playing");
      $('.player.' + key + ' input[type=range]').val(50); // Setze Slider auf Standardwert
      // $('body').removeClass(key);
    }
  }

  function playPauseTracker($player, $event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'formLocation': $player,
      'event': $event
    });
  }

  function setupPlayer(playerSelector, audioSelector, playState) {
    let audioPlayer = $(audioSelector)[0];
    let playerWrapper = $(playerSelector)[0];
    const body = $('body')

    body.on("click", playerSelector, function (e) {
      e.stopPropagation();
      e.preventDefault();
      // If classlist is 1 it means, that the player is not running nor paused.
      if (e.target.classList.length === 1) {
        $(playerSelector + ' .play').click();
      }
    });

    body.on("click", `${playerSelector} .play, ${playerSelector} .pause`, function (e) {
      e.stopPropagation();
      e.preventDefault();
      resetAllPlayers();
      const isGrischaPlayer = playerSelector === ".player.grischa";

      // if playstateRSO and current clicked element is grischa player play switch from rso to grischa.
      // else if playstateGrischa and current clicked element is rso player play switch from grischa to rso.
      if (playStateRSO || playStateGrischa) {
        // rso is currently playing
        if (playStateRSO) {
          // new player should be grischa
          if(isGrischaPlayer) {
            playPauseTracker('Radio Suedostschweiz', 'pause');
            playPauseTracker('Radio Grischa', 'play');
            playPauseTracker('RSO to GRISCHA', 'switch');
          }
          // pause rso
          else {
            playPauseTracker('Radio Suedostschweiz', 'pause');
          }
        }
        // grischa is currently playing
        else {
          // new player should be rso
          if(!isGrischaPlayer) {
            playPauseTracker('GRISCHA to RSO', 'switch');
            playPauseTracker('Radio Grischa', 'pause');
            playPauseTracker('Radio Suedostschweiz', 'play');
          }
          // pause grischa
          else {
            playPauseTracker('Radio Grischa', 'pause');
          }
        }
      }
      // currently no player is playing
      else {
        // start grischa
        if (isGrischaPlayer) {
          playPauseTracker('Radio Grischa', 'play');
        }
        // start rso
        else {
          playPauseTracker('Radio Suedostschweiz', 'play');
        }
      }

      if(isGrischaPlayer) {
        playStateGrischa = e.currentTarget.className === 'play';
        playStateRSO = false;
      } else {
        playStateRSO = e.currentTarget.className === 'play';
        playStateGrischa = false;
      }

      if (playStateRSO || playStateGrischa) {
        audioPlayer.load();
        audioPlayer.play().then(() => {
          $(playerWrapper).addClass("playing");
          body.removeClass('rso');
          body.removeClass('grischa');
          body.addClass(isGrischaPlayer ? 'grischa' : 'rso');
        })
      }
    });

    const volumeSlider = $(playerSelector + ' input[type=range]')[0];
    volumeSlider.addEventListener('input', (e) => {
      e.stopPropagation();
      e.preventDefault();
      const value = e.target.value < 10 ? 10 : e.target.value;
      $(playerWrapper).css('--volume-before-width', value / e.target.max * 100 + "%");
      audioPlayer.volume = value / 100;
    });

    const muteIconContainer = $(playerSelector + ' .mute')[0];
    muteIconContainer.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      $(playerWrapper).addClass("muted");
      audioPlayer.muted = true;
    });

    const unmuteIconContainer = $(playerSelector + ' .unmute')[0];
    unmuteIconContainer.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      $(playerWrapper).removeClass("muted");
      audioPlayer.muted = false;
    });
  }

  Drupal.behaviors.rso = {
    attach: function (context, settings) {

      $(document, context).once('rso').each(() => {
        // Navigation toggle.
        $('body').on("click", ".mobile-toggle", function (e) {
          $(".menu--main .menu").toggleClass("open");
          $(".mobile-toggle").toggleClass("open");
        });

        // Setup both players
        setupPlayer(".player.grischa", "#audio-grischa", playStateGrischa);
        setupPlayer(".player.rso", "#audio-rso", playStateRSO);

        navigator.mediaSession.setActionHandler('play', () => {
          $(".player.rso .play").click();
        });
        navigator.mediaSession.setActionHandler('pause', () => {
          $(".player.rso .pause").click();
        });
        navigator.mediaSession.setActionHandler('play', () => {
          $(".player.grischa .play").click();
        });
        navigator.mediaSession.setActionHandler('pause', () => {
          $(".player.grischa .pause").click();
        });

      });
    }
  };

}(jQuery, Drupal));
